// extracted by mini-css-extract-plugin
export var image = "styles-module--image--92546";
export var imagePanel = "styles-module--imagePanel--e1241";
export var title = "styles-module--title--c5f00";